export { default } from './cms-image'
